import React, { useState } from "react";
import { string, object, bool, func } from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";

import { AdContainer } from "../../ads";
import "./sticky-banner.m.css";
import useAdType from "../../helper/custom-hook/useAdType";

const StickyBanner = ({ hasBottomNav = false, isVisible = true, onClose }) => {
  const pageType = useSelector((state) => get(state, ["qt", "pageType"]));
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
  const subscriptionConfig = get(qtState, ["data", "subscriptionConfig", "ad-lite-cta"], {});
  const [showAd, setShowAd] = useState(true);
  const adType = useAdType();

  const handleClose = () => {
    setShowAd(false);
    if (onClose) {
      onClose();
    }
  };

  const adsId = {
    "story-page": "div-gpt-ad-1675837571080-0",
    "home-page": "div-gpt-ad-1675837460755-0",
    "izooto-sticky": "div-gpt-ad-1711631305087-0"
  };

  const ads = {
    "story-page": "PV_Mweb_AP_Sticky",
    "home-page": "PV_Mweb_HP_Sticky",
    "izooto-sticky": "PV_Mweb_AP_Sticky_ym"
  };

  return (
    <div styleName="wrapper" id="sticky-banner-id">
      {showAd && isVisible && !isAdfree && (
        <div styleName={hasBottomNav ? "banner" : "banner no-bottom-nav"}>
          <div styleName="cross-btn" onClick={handleClose}>
            &#xd7;
          </div>
          <div styleName="ad-wrapper">
            <span styleName="ad-text">
              {subscriptionConfig?.["advertisment-text"] || "ಜಾಹೀರಾತು. "}
              <a 
                href="/subscribe?utm_source=pv_site&utm_medium=ad_cta&utm_campaign=pv_subscription" 
                style={{ textDecoration: "underline" }} 
                styleName="red-text"
                onClick={(e) => {
                  e.preventDefault();
                  if (window) {
                    const { getAuthStatus } = require("../../helper/datalayer-utils");
                    const { status, uuid } = getAuthStatus();
                    const formattedStatus = status === "not_logged_in" ? "non_logged_in" : status;
                    
                    let slotName = adType === "izooto" ? ads["izooto-sticky"] : ads[pageType] || "PV_Mweb_HP_Sticky";
                    
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: "ad_lite_button_click",
                      ad_slot_name: slotName,
                      auth_status: formattedStatus,
                      uuid: uuid
                    });
                  }
                  setTimeout(() => {
                    window.location.assign("/subscribe?utm_source=pv_site&utm_medium=ad_cta&utm_campaign=pv_subscription");
                  }, 300);
                }}
              >
                {subscriptionConfig?.["cta-text"] || "Go Ad Lite"}
              </a>
            </span>
            <div styleName="sticky-ad">
              <AdContainer
                showText={false}
                id={adType === "izooto" ? adsId["izooto-sticky"] : adsId[pageType] || "div-gpt-ad-1675837460755-0"}
                mobile={adType === "izooto" ? ads["izooto-sticky"] : ads[pageType] || "PV_Mweb_HP_Sticky"}
                isExternalAdPath={adType === "izooto" ? true : false}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

StickyBanner.propTypes = {
  pageType: string,
  story: object,
  hasBottomNav: bool,
  isVisible: bool,
  onClose: func
};

export default StickyBanner;
